module.exports = __webpack_public_path__ + "img/icon-products-magento-61.2a526dad.svg";